function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M-9.94325e-05 6.59385C11.001 6.59385 19.9219 11.2853 38.5125 11.2853C57.1031 11.2853 61.985 -5.99676 77.0251 6.59385C92.0652 19.1845 78.1551 31.02 83.8999 51.3921C89.6447 71.7641 100.828 70.5 100.827 91",
  stroke: "#23313A",
  strokeWidth: 3
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0.000982532 22.7164C15.0006 22.7164 21.0171 26.5117 35.9625 26.5117C50.9079 26.5117 54.8325 12.5307 66.9236 22.7164C79.0146 32.902 67.8321 42.4769 72.4504 58.9576C77.0688 75.4384 86.0582 74 86.0586 91",
  stroke: "#23313A",
  strokeWidth: 8
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0.00098104 39.7873C11.501 39.7873 16.1288 42.6338 27.4248 42.6338C38.7207 42.6338 41.687 32.148 50.8256 39.7873C59.9642 47.4265 51.5122 54.6077 55.0028 66.9682C58.4935 79.3288 65.2884 78.5 65.2881 91",
  stroke: "#23313A",
  strokeWidth: 3
});

function SvgPattern2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "pattern",
    width: 103,
    height: 91,
    viewBox: "0 0 103 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _ref2), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _ref3), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _ref4));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern2);
export default __webpack_public_path__ + "static/media/pattern-2.9b9ff992.svg";
export { ForwardRef as ReactComponent };